import { Controller } from "@hotwired/stimulus"

// Auto-submits the invoice table's filter form so search feels live while the
// actual filtering/sorting/pagination runs server-side (the form GETs into the
// `documents_data` Turbo Frame). Search input is debounced so we send one
// request after a typing pause, not one per keystroke; date changes submit
// immediately. Sort headers, status chips, and the pager are plain
// frame-targeted links and need no JS.
//
// The search field is `data-turbo-permanent`, so Turbo keeps the same input
// element (and its focus + caret) when the frame reloads with results.
export default class extends Controller {
  static targets = ["form"]
  static values = { delay: { type: Number, default: 350 } }

  submit() {
    this.formTarget.requestSubmit()
  }

  debouncedSubmit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
